module.exports = __webpack_public_path__ + "images/emoji/arrows_counterclockwise.87a2e388097dc4678d06.png";